export function print()
{
    window.print();
}
export interface ICopyHtmlToPrint {
    title: string,
    classID: string,
    classOverRide?: string[],
    timeoutMS?: number
};
export function CopyHtmlToPrint(printInformation : ICopyHtmlToPrint) : void {
    const elms = document.querySelectorAll(`div[class~="${printInformation.classID}"]`);
    const window_style_sheets = document.querySelectorAll(`link[rel="stylesheet"]`);  
    const printWindow = window.open('', '', 'width=800,height=600'); 
    let printContent = "";

    elms.forEach((elm) => {
        printContent += elm.innerHTML;
    });

    if ((printWindow) && (printContent)) { 
        if (printInformation.classOverRide)  {
            printInformation.classOverRide.forEach((className) => {
                printContent = (printContent ?? "").replace(className, `${className}-override`);
            });
        } 
        printWindow.document.write(`<html><head><title>${printInformation.title}</title>`); 
        window_style_sheets.forEach(sheet => {
            printWindow.document.write(sheet.outerHTML);
        }); 
        printWindow.document.write('</head><body>'); 
        printWindow.document.write(printContent); 
        printWindow.document.write('</body></html>');    
        printWindow.document.write('<script type="text/javascript">');
        printWindow.document.write('window.addEventListener("afterprint", () => { window.setTimeout(() => { window.close(); }, 2500); });');
        printWindow.document.write(`window.setTimeout(() => { window.close(); }, ${ (printInformation.timeoutMS ? printInformation.timeoutMS : 30000)});`); 
        printWindow.document.write('<' + '/script>'); 
        printWindow.document.close();
        printWindow.print(); 
    } 
    else {
        console.error('Failed to open print window');
    }       
}